import React, { useState } from 'react';
import { Dropdown, FormControl, FormText } from 'react-bootstrap';

const handleKeyPress = (e, onSelection) => {
  if (e.key === 'Enter') {
    onSelection(e.target.value);
    e.target.value = '';
    return false;
  }

  if (e.key === 'Escape') {
    e.preventDefault();
    return false;
  }

  return true;
}

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <FormText
    ref={ref}
    style={{fontSize: '16px'}}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
    &nbsp;
    &#x25bc;
  </FormText>
));

const CustomMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy, onSelection }, ref) => {
    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <FormControl
          autoFocus
          className="mx-3 my-2 w-auto"
          placeholder="Type a specific time..."
          onKeyDown={(e) => handleKeyPress(e, onSelection) }
        />
        <ul className="list-unstyled">
          {React.Children.toArray(children)}
        </ul>
      </div>
    );
  },
);

const TextBoxDropdown = ({onValueChanged, defaultValue}) => {
  const [value, setValue] = useState();
  const [showDropdown, setShowDropdown] = useState(false);

  const setDropdown = () => {
    setShowDropdown(!showDropdown);
  }

  const OnSelection = (e) => {    
    setValue(e);
    setShowDropdown(false);
    onValueChanged(e);
  }

  return (
    <Dropdown show={showDropdown} style={{float: 'left'}}>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" onClick={setDropdown}>
        {value && (
          <>{value}</>
        )}
        {!value && (
          <>{defaultValue}</>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu as={CustomMenu} onSelection={(e) => OnSelection(e)}>
        {[defaultValue, '1 hour ago', '3 hours ago', '6 hours ago', '12 hours ago', '24 hours ago', '2 days ago', '3 days ago', '7 days ago'].map((option) => (
          <Dropdown.Item key={option} onClick={(e) => OnSelection(e.target.innerText)}>{option}</Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default TextBoxDropdown;
